<mat-card-title mat-dialog-title class="d-flex align-items-center mb-1">
  <mat-icon class="mr-2">{{ icon }}</mat-icon>
  {{ title }}
</mat-card-title>
<mat-card-subtitle class="popup-subtitle mb-1">{{
  subTitle
}}</mat-card-subtitle>
<mat-divider></mat-divider>
<mat-dialog-content>
  <form [formGroup]="remarksFormGroup">
    <mat-form-field appearance="fill">
      <mat-label>{{ 'shared.remarks-popup.label' | translate }}</mat-label>
      <textarea type="text" matInput formControlName="remarks"></textarea>
      <mat-error *ngIf="remarksFormGroup.controls.remarks.hasError('required')">
        {{ 'shared.remarks-popup.remarks-required-error' | translate }}
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onClickClose()">
    {{ 'shared.remarks-popup.cancel' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="outputData()"
    [disabled]="isRequired && remarksFormGroup.controls.remarks.invalid"
  >
    {{ buttonText }}
  </button>
</mat-dialog-actions>
